<template>
  <div class="w breadcrumb">
    <i class="el-icon-s-home">当前位置：</i>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="item in breadList" :key="item.name">
        <router-link v-if="item.name != name" :to="{ path: item.path === '' ? '/' : item.path }">{{ item.meta.title }}</router-link>
        <span v-else>{{ item.meta.title }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      breadList: []
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      this.breadList = []
      this.name = this.$route.name
      this.$route.matched.forEach(item => {
        this.breadList.push(item)
      })
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  align-items: center;
  height: 50px;
}
</style>
